import { Component, OnInit } from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import { environment } from '../../../../environments/environment';
import {AuthService} from '../../../services/auth/auth.service';
import { SelectItem } from 'primeng/api';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import {SolicitarconfirmacionService} from '../../../services/auth/solicitarconfirmacion.service';

@Component({
  selector: 'app-solicitar-confirmacion',
  templateUrl: './solicitar-confirmacion.component.html',
  styleUrls: ['./solicitar-confirmacion.component.css'],
  providers: [ConfirmationService, MessageService],
})
export class SolicitarConfirmacionComponent implements OnInit {
  /**
   * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
   *
   * code: Código del mensaje de respuesta a mostrar en la función.
   * titulo: Título a enviar; solo si se recibe con la respuesta del endpoint.
   * detalle: Detalle a enviar; solo si se recibe con la respuesta del endpoint.
   */
  correo: string;
  credentialsForm: FormGroup;
  visibleSpinner = false;
  infoexito = '';
  regExpCorreo: string = environment.regExpCorreo;

  // Variables para mensaje
  code: any;
  titulo: any;
  detalle: any;

  constructor(private formBuilder: FormBuilder, private router: Router, private authService: AuthService,
              private confirmationService: ConfirmationService,
              private messageService: MessageService,
              private confirmarService: SolicitarconfirmacionService) { }

  ngOnInit(): void {
    this.credentialsForm = this.formBuilder.group({
      correo: ['', [Validators.required, Validators.pattern(this.regExpCorreo)]]
    });

    document.getElementById('correo').focus();
  }

  confirm() {
    const CORREO_USUARIO = this.credentialsForm.value.correo;
    this.visibleSpinner = true;

    this.confirmarService.reenviarcodigoconfirmacion(CORREO_USUARIO).subscribe((res: any) => {
      if (res.success) {
        this.visibleSpinner = false;
        this.infoexito = 'Estimado usuario se ha enviado con éxito un nuevo correo de verificación a ' + CORREO_USUARIO;
        this.code = 'solicitar_confirmacion.success.default';
        this.detalle = this.infoexito;
        setTimeout(() => {
          this.router.navigate(['auth/login']);
        }, 1500);
      } else {
          let errores = '';
          if (res.data.message === 'Ver errores en extras') {
              if (res.data.extra.length > 1) {
                  errores += '<ul>';
                  errores += '<li>' + res.data.extra.join('</li><li>') + '</li>';
                  errores += '</ul>';
              } else {
                  errores = res.data.extra[0];
              }
          } else {
              errores = res.data.message;
          }
          this.visibleSpinner = false;
          this.code = 'solicitar_confirmacion.warn.default';
          this.detalle = errores;
      }
    }, error => {
      // console.log('Error ', error);
      this.visibleSpinner = false;
      this.code = 'solicitar_confirmacion.error.default';
      this.detalle = error;
    });
  }

}
